import Button from 'components/Button';
import Dialog from 'components/Dialog';
import { getOrderContext } from 'contexts/order';
import React from 'react';
import { NotificationManager } from 'react-notifications';
import styled from 'styled-components';
import Cardbox from '../Cardbox';
import FlexDivider from '../FlexDivider';
import ComboPopup from './ComboPopup';

const Combo = ({ data: comboRows }) => {
    const [selectedCombo, setSelectedCombo] = React.useState(null)
    const {menus, setMenus, address} = React.useContext(getOrderContext)
    const handleAddMenu = () => {
        let isValidProcess = true
        if(!selectedCombo.comboMainItems.selected) {
            NotificationManager.warning('Та үндсэн бүтээгдэхүүн сонгоно уу!', '', 10000)
            isValidProcess = false
        }
        selectedCombo.comboSideItems.forEach(side =>{
            if(!side.selected) {
                NotificationManager.warning(`Та ${side.name} ${side.groupType} бүтээгдэхүүн сонгоно уу!` ,'', 10000)
                isValidProcess = false
            }
        })
        if(isValidProcess) {
            const effectivePrice = !address.haveDelivery && selectedCombo.pickupPrice != null
                ? selectedCombo.pickupPrice
                : selectedCombo.defaultPrice;
            const comboObject = {
                id: selectedCombo.id,
                type: "combo",
                count: 1,
                masterName: selectedCombo.masterName,
                comboMenuId: selectedCombo.comboMenuId,
                primaryComboGroupId: selectedCombo?.comboMenuId ,
                comboMainItems: selectedCombo.comboMainItems.selected,
                comboSideItems: selectedCombo.comboSideItems.map(x => x.selected),
                // defaultPrice: selectedCombo.defaultPrice,
                defaultPrice: effectivePrice,
                // price: effectivePrice,
                price: selectedCombo.price,
            }
            setMenus([...menus, comboObject])
            setSelectedCombo(null)
        }
    }
    return (
        <Container>
            <FlexDivider>
                {comboRows.map((comboMenu, i) => (
                    <Cardbox
                        key={comboMenu.id + '' + comboMenu.comboMenuId}
                        name={comboMenu.masterName}
                        price={!address.haveDelivery && comboMenu.pickupPrice != null ? comboMenu.pickupPrice : comboMenu.defaultPrice} 
                        img="combo"
                        // price={comboMenu.defaultPrice} img="combo"
                        imgUrl={comboMenu.imageUrl}
                        desc={comboMenu.description}
                        onClick={() => setSelectedCombo(comboMenu)}
                        data={comboMenu}
                    >
                        {/* <div>
                            <p><b>-{comboMenu.comboMainItems.type}</b></p>
                            {comboMenu.comboSideItems.map(sideItem =>(
                                <p key={Math.random()}>-{sideItem.optionName}</p>
                            ))}
                        </div> */}
                    </Cardbox>
                ))}
            </FlexDivider>
            {selectedCombo &&
                <Dialog
                    width={'600px'}
                    title={selectedCombo.masterName}
                    submit={<Button bg="green" onClick={handleAddMenu}>Багц нэмэх</Button>}
                    onClose={() => setSelectedCombo(null)}
                >
                    <ComboPopup onChange={handleAddMenu} instance={selectedCombo} setSelectedCombo={setSelectedCombo} />
                </Dialog>
            }
        </Container>
    );
};

export default Combo;

const Container = styled.div`
    width:100%;
`